var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeaveIcon = function SvgLeaveIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.504 19c-.827 0-1.5-.673-1.5-1.5v-2.481h1V17.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-12a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5v2.478h-1V5.5c0-.827.673-1.5 1.5-1.5h11c.827 0 1.5.673 1.5 1.5v12c0 .827-.673 1.5-1.5 1.5h-11ZM5.31 14.81 2 11.5l3.31-3.31.707.707-2.103 2.102h10.09v1H3.914l2.103 2.104-.707.707Z",
    fill: "#000"
  })));
};
export default SvgLeaveIcon;